<template>
  <div class="my-2 pa-3 encarte-card">
    <span class="pa-1 title">Caça-ofertas</span>
    <v-container fluid class="pa-1">
      <v-layout>
        <v-flex xs6>
          <v-list class="my-3">
            <v-list-item>
              <span class="list-item"
                >{{ items[0].text }} <strong class="ml-2">{{ items[0].value | localeString }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[1].text }} <strong class="ml-2">{{ items[1].value | localeString(2) | currency }}</strong></span
              >
            </v-list-item>
            <v-list-item>
              <span class="list-item"
                >{{ items[2].text }} <strong class="ml-2">{{ items[2].value | localeString(1) | percent }}</strong></span
              >
            </v-list-item>
          </v-list>
        </v-flex>
        <v-flex xs1 offset-xs1> </v-flex>
        <v-flex xs4>
          <encarte-chart id="compraram-chart" class="chart" is-percent :chartData="chartData" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import EncarteChart from '@/modules/campanhas/resultados-encarte/views/pages/EncarteChart.vue'
import { mapGetters } from 'vuex'
import { colors } from '@/config/colors.js'

export default {
  components: {
    EncarteChart,
  },
  computed: {
    ...mapGetters(['cuponsSoEncarte', 'ticketMedioSoEncarte', 'cacaOfertas']),
    items() {
      return [
        {
          text: 'Cupons caça-ofertas (só com produtos do encarte)',
          value: this.cuponsSoEncarte,
        },
        {
          text: 'Ticket médio dos cupons caça-ofertas',
          value: this.ticketMedioSoEncarte,
          isCurrency: true,
        },
        {
          text: 'Percentual de cupons caça-ofertas',
          value: this.cacaOfertas,
          isPercent: true,
        },
      ]
    },
    chartData() {
      return {
        labels: ['Só Encarte'],
        datasets: [
          {
            label: 'Porcentagem',
            backgroundColor: colors[0],
            strokeColor: colors[0],
            borderColor: colors[0],
            data: [this.cacaOfertas],
            fill: false,
            datalabels: { display: true },
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss">
.encarte-card {
  .chart {
    max-height: 350px;
  }
}
</style>
